"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.HighlightValueLabels = exports.Point = void 0;

var _react = _interopRequireWildcard(require("react"));

var _useColors = _interopRequireDefault(require("../../hooks/use-colors"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { default: obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var HOV_SIZE = 50;

var Point = function Point(_ref) {
  var x = _ref.x,
      y = _ref.y,
      value = _ref.value,
      t = _ref.t,
      color = _ref.color,
      width = _ref.width;

  var _useState = (0, _react.useState)(false),
      _useState2 = _slicedToArray(_useState, 2),
      showPoint = _useState2[0],
      setShowPoint = _useState2[1];

  var onShow = (0, _react.useCallback)(function () {
    return setShowPoint(true);
  }, [setShowPoint]);
  var onHide = (0, _react.useCallback)(function () {
    return setShowPoint(false);
  }, [setShowPoint]);
  return /*#__PURE__*/_react.default.createElement("g", {
    onMouseEnter: onShow,
    onMouseLeave: onHide
  }, showPoint && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("text", {
    x: x + 10,
    y: y - 10,
    fill: color
  }, value), /*#__PURE__*/_react.default.createElement("circle", {
    cx: x,
    cy: y,
    r: 5,
    fill: color
  })), /*#__PURE__*/_react.default.createElement("rect", {
    x: x - width / 2,
    y: y - HOV_SIZE / 2,
    width: width,
    height: HOV_SIZE,
    fill: "transparent" // If you're debugging the hover region, uncomment the following
    // fill="rgba(0,0,0,0.5)"

  }));
};

exports.Point = Point;

var HighlightValueLabels = function HighlightValueLabels(_ref2) {
  var _ref2$visibleTransfor = _ref2.visibleTransformedPointsOnCurves,
      visibleTransformedPointsOnCurves = _ref2$visibleTransfor === void 0 ? [] : _ref2$visibleTransfor,
      _ref2$curveColors = _ref2.curveColors,
      curveColors = _ref2$curveColors === void 0 ? [] : _ref2$curveColors;
  return /*#__PURE__*/_react.default.createElement("g", null, visibleTransformedPointsOnCurves.flatMap(function (points, curveIndex) {
    return points.map(function (p, i) {
      return /*#__PURE__*/_react.default.createElement(Point, _extends({
        key: "".concat(curveIndex, ",").concat(i),
        color: curveColors[curveIndex],
        width: i === 0 || i === points.length - 1 ? HOV_SIZE : (points[i + 1].x - points[i - 1].x) / 2
      }, p));
    });
  }));
};

exports.HighlightValueLabels = HighlightValueLabels;
var _default = HighlightValueLabels;
exports.default = _default;